import { useQuery } from 'react-query'
import { mechanicService } from '@services/mechanicService'

interface MechanicParams {
  workshopCompanyId?: number
  mechanicId?: number
}

export function useMechanicPendingWorkOrders({ workshopCompanyId, mechanicId }: MechanicParams) {
  const isEnabled = typeof workshopCompanyId === 'number' && workshopCompanyId > 0
  
  // Debug log
  if (typeof window !== 'undefined') {
    console.log('useMechanicPendingWorkOrders:', { workshopCompanyId, mechanicId, isEnabled })
  }
  
  return useQuery(
    ['mechanicPendingWorkOrders', workshopCompanyId, mechanicId],
    () => {
      console.log('Fetching work orders:', { workshopCompanyId, mechanicId })
      return mechanicService.getPendingWorkOrders({
        workshopCompanyId: workshopCompanyId as number,
        mechanicId,
      })
    },
    {
      enabled: isEnabled,
      staleTime: 0, // Always refetch
      cacheTime: 0, // Don't cache
    }
  )
}

export function useMechanicPendingClients({ workshopCompanyId, mechanicId }: MechanicParams) {
  return useQuery(
    ['mechanicPendingClients', workshopCompanyId, mechanicId],
    () =>
      mechanicService.getPendingClients({
        workshopCompanyId: workshopCompanyId as number,
        mechanicId,
      }),
    {
      enabled: typeof workshopCompanyId === 'number' && workshopCompanyId > 0,
    }
  )
}

export function useMechanicAllClients({ workshopCompanyId, mechanicId }: MechanicParams) {
  return useQuery(
    ['mechanicAllClients', workshopCompanyId, mechanicId],
    () =>
      mechanicService.getAllClients({
        workshopCompanyId: workshopCompanyId as number,
        mechanicId,
      }),
    {
      enabled: typeof workshopCompanyId === 'number' && workshopCompanyId > 0,
    }
  )
}



